import * as React from 'react'
import { Route, Switch } from 'react-router-dom'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { ListIE } from 'Pages/interfaceElement'

export const InterfaceElementRoutes = () => {
	return (
		<Switch>
			<Route exact path={`${FrontUrls.access}`} component={ListIE} key={`${FrontUrls.access}`} />
		</Switch>
	)
}
